export enum EProjectFilters {
  cexOrders = 'cexOrders',
  cexTrades = 'cexTrades',
}

export type ProjectFilterScope = {
  projectId: number;
  projectType: EProjectFilters;
};
